<!--
 * @Author: zhx
 * @Date: 2020-12-30 13:48:07
 * @LastEditTime: 2020-06-16 14:48:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\views\login\noauthority.vue
-->
<template>
  <div class="noauthority">
    <van-nav-bar title="暂无权限" left-arrow @click-left="backLogin()"></van-nav-bar>
    <div class="container">
      <img src="../../assets/default_noauthority.png" />
      <span class="titleText">暂无权限，请联系管理员</span>
      <span>或在电脑端申请权限。</span>
      <button type="button" class="backBtn" @click="backLogin()">返回登录页</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'noauthority',
  data () {
    return {};
  },
  created () {},
  methods: {
    backLogin () {
      this.$axios
        .post('api/logout', {
          version: this.$version,
          data: { token: this.$store.state.token }
        })
        .then((res) => {
          if (res.status) {
            localStorage.clear();
            this.$router.push('/login');
          }
        });
    }
  },
  watch: {},
  computed: {},
  components: {}
};
</script>
<style lang="scss" scoped>
.noauthority {
  width: 100%;
  height: calc(100vh - 52px);
  background: $sligtblueF7FBFF;
  .container {
    width: 100%;
    height: 100%;
    clear: both;
    padding: 120px 25%;
    img {
      height: 148px;
    }
    .titleText {
      margin: 20px 0 4px 0;
    }
    span {
      font-size: 14px;
      color: $black;
      letter-spacing: 0.22px;
      text-align: center;
      line-height: 21px;
      display: inline-block;
      clear: both;
      width: 96%;
    }
    button {
      border: $blueborder;
      border-radius: 4px;
      font-size: 14px;
      color: $blue;
      letter-spacing: 0;
      text-align: center;
      display: inline-block;
      width: 108px;
      height: 40px;
      background: $transparent;
      margin: 32px 15% 0 15%;
    }
  }
}
</style>
